import React from 'react';
import styled from 'styled-components';
import "./style.scss";

export const Title = function(props){
    return <div className="idw-h1">
        {props.sub ? <div className="sub"> {props.sub} </div> : null}
        <div className="main">{props.main}</div>
        <div className="line line1"></div>
        <div className="line line2"></div>
    </div>
}